/* eslint-disable */
import HttpService from '../HttpService';
export default class PlanService {
    constructor() {
      this._httpService = new HttpService('/contract/beneficiary_contracted_plan');
    }

    async FindOne(id){
        return await this._httpService.get( `/${id}`);
    }
 };
